module.exports = __webpack_public_path__ + "5103ea91aa3ad5cec67e3799cc85817c.svg";